module.exports = __webpack_public_path__ + "static/media/BurgerLounge-Contained.1529f298.jpg";